import { define } from '../../define.js';
import { CarouselItem } from './carousel-item.js';
export * from './carousel-item.js';
define('carousel-item', CarouselItem);
